export default "__VITE_ASSET__Di9CjC61__"